import React from "react";
import Img from "../../Assets/Images/Birth_Image1.jpeg";
import "./successstories.css";
import SSBlock from "../../Components/SuccessStoryBlock/SSBlock";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import SEO from "../../Components/SEO";

const SuccessStoriesBlock = [
  {
    image: "https://www.youtube.com/embed/CaLmFwizNTg",
    name: "JOSEPH MANFREDI",
    subtitle: "The Ultimate Student Athlete",
    description:
      "Joseph Manfredi has been coming to Shootin’ School since he is in the 3rd grade! He is attends one of the top schools in NYC. He is the first Sophomore to play Varsity on his High School team, is on track to score 1,000 High School career points, and aspires to play Division I basketball at an Ivy league School.",
  },
  {
    image: "https://www.youtube.com/embed/bkkZwxRzfX4",
    name: "THE MITCHELLS",
    subtitle: "8 years of Shootin' School",
    description:
      "The 3 Mitchell kids have been training with Shootin’ School since 2009. After 8 years of dedication and training, take a look at how Shootin’ School played a part in their success.",
  },
  {
    image: "https://www.youtube.com/embed/7O6Rimlg76Y",
    name: "ANDREW FEELEY",
    subtitle: "14 Year Professional",
    description:
      "Andrew Feeley was already a professional basketball player when he started working out with Shootin’ School. Take a look at how Shootin’ School was able to help Andrew take his game to the next level.",
  },
  {
    image: "https://www.youtube.com/embed/y6jZ74LKgxE",
    name: "JULIE LAGUNA",
    subtitle: "The First Unlimited",
    description:
      "Julie Laguna has been coming to Shootin’ School since she is in the 4th grade! She is the first Shootin’ School Unlimited Plan participant! The program helped accelerate her skill development and ultimately allowed her to reach some of her early childhood basketball goals. She’s currently playing at one of the top High School Basketball programs in the country at Christ the King.",
  },
  {
    image: "https://www.youtube.com/embed/uqGlYMap4Wk",
    name: "NICOLE MELIOUS",
    subtitle: "The 1st Freshman Jacques Award Winner",
    description:
      "Nicole Melious has been coming to Shootin’ School since she is in the 5th grade! Currently, she is playing at Wagner High School. After her freshman year, she’s accumulated 755 points and secured Staten Island’s prestigious Jacques Award as a freshman; the first player EVER to do so! Nicole has already committed to DI, Purdue University!",
  },
];

const SuccessStories = () => {
  return (
    <>
      <SEO
        title="Shootin' School Success Stories - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/shootin-school-success-stories/"
      />

      <div className="success-story-container">
        <div className="sss-layout">
          <div className="sss-layout-header">
            <span>Shootin’ School </span>
            <h1>Success Stories</h1>
          </div>
          <div className="sss-grid">
            {SuccessStoriesBlock.map((successstory, i) => (
              <SSBlock
                key={i}
                image={successstory.image}
                name={successstory.name}
                subtitle={successstory.subtitle}
                description={successstory.description}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="about-sponsors sss-sp brightness bg-custom">
        <Sponsors brValue={1} />
      </div>
    </>
  );
};
export default SuccessStories;
